var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.clientChangeState)?_c('div',{staticStyle:{"display":"flex","align-items":"center"}},[_c('my-el-button',{staticStyle:{"margin-right":"10px"},attrs:{"check":""},on:{"click":_vm.applyClientChanges}}),(_vm.clientChangeState === 'insert')?_c('div',[_vm._v(" Это новая запись")]):_c('div',[_vm._v("Есть изменения")])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }